import React from 'react';

import DashboardLayout from './../../layouts/dashboard';

import Grid from '@material-ui/core/Grid';

import { ReportsTravels } from './../../../components/Reports/Travels';

export const ReportsTravelsPage = () => {
  return (
    <DashboardLayout title={'Reporte de Viajes'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <ReportsTravels />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
